// Readable name for an icon file, for screen readers and labels.
// "ms-ramen-dining.svg" -> "ramen dining", "cat-fill.svg" -> "cat"
export const iconLabel = (file: string): string =>
  file.replace(/^ms-/, "").replace(/(-fill)?\.svg$/, "").replace(/-/g, " ");
